module.exports = __webpack_public_path__ + "img/P150T_weapon_74.291ab656.png";